import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import type { UserConsentInfo } from "../../../../api/types/userConsentTypes";
import UserConsentCategoryTag from "./UserConsentCategoryTag";
import { useUserConsentsSectionContext } from "./UserConsentsSectionContext";

export const ActionCell = ({ row }: { row: UserConsentInfo }) => {
  const { hasEditPermissions, onDeleteConsent } = useUserConsentsSectionContext();

  if (!hasEditPermissions) {
    return null;
  }

  return (
    <ActionsMenuButton
      items={[
        {
          icon: <DeleteIcon color="error" />,
          label: "Delete",
          onClick: () => onDeleteConsent(row.name),
        },
      ]}
    />
  );
};

export const CategoryCell = ({ row }: { row: UserConsentInfo }) => {
  const { categories } = useUserConsentsSectionContext();
  if (categories.length === 0) {
    return null;
  }

  return <UserConsentCategoryTag categoryId={row.categoryId} />;
};
